import {message} from "antd";
import {validateEmail} from "helper/validate";
import {FIELD_TYPE} from "types/enums";

const {INPUT, INPUT_PASSWORD, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Username",
    name: "username",
    rules: [{required: true, message: "Chưa nhập username"}],
  },
  {
    type: INPUT_PASSWORD,
    label: "Mật khẩu",
    name: "pass",
    rules: [{required: true, message: "Chưa nhập mật khẩu"}],
  },
  {
    type: INPUT,
    label: "Tên",
    name: "lastName",
  },
  {
    type: INPUT,
    label: "Họ",
    name: "firstName",
  },
  {
    type: INPUT,
    label: "Email",
    name: "email",
    // rules: [
    //   {message: "Email không đúng định dạng", validator: validateEmail},
    //   {required: true, message: "Chưa nhập email"},
    // ],
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "enabled",
    options: [
      {value: true, label: "Hoạt động"},
      {value: false, label: "Dừng hoạt động"},
    ],
  },
];
const columnsRole: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    show: true,
    align: "center",
    width: 60,
  },
  {
    title: "Role",
    dataIndex: "id",
    key: "id",
    type: COMBO_BOX,
    show: true,
  },

  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
const columnsBranch: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 60,
    show: true,
    align: "center",
  },
  {
    title: "Chi nhánh",
    dataIndex: "id",
    key: "id",
    type: COMBO_BOX,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
const columnsKhoDuoc: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 60,
    show: true,
    align: "center",
  },
  {
    title: "Kho dược",
    dataIndex: "id",
    key: "id",
    type: COMBO_BOX,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
const columnsKhoKinh: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 60,
    show: true,
    align: "center",
  },
  {
    title: "Kho kính",
    dataIndex: "id",
    key: "id",
    type: COMBO_BOX,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
const columnsKhoVT: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 60,
    show: true,
    align: "center",
  },
  {
    title: "Kho vật tư",
    dataIndex: "id",
    key: "id",
    type: COMBO_BOX,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {
  fields,
  columnsRole,
  columnsBranch,
  columnsKhoDuoc,
  columnsKhoKinh,
  columnsKhoVT,
};
